// Must be the FIRST import: patches ResizeObserver before any library (recharts,
// etc.) is evaluated and could capture the native constructor.
import './suppressResizeObserverLoop';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// GLOBAL FIX: Prevent scroll wheel from changing number input values
// This is a critical bug fix that prevents accidental value changes when scrolling
document.addEventListener('wheel', function(e) {
  const target = e.target as HTMLElement;
  if (target && target.tagName === 'INPUT' && (target as HTMLInputElement).type === 'number') {
    // Blur the input to prevent value change
    (target as HTMLInputElement).blur();
    // Prevent the default scroll behavior on the input
    e.preventDefault();
  }
}, { passive: false });

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
